<template>
  <div class="teen-page teen2">
    <div class="header">
      <h1>天下第一奇山：黄山</h1>
    </div>

    <div class="container">
      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_2.png" alt="黄山日出">
        <div class="caption">黄山日出，云海翻涌，美不胜收</div>
      </div>

      <h2>一、 黄山的由来</h2>
      <p>黄山位于安徽省南部，是中国著名的风景名胜区。传说轩辕黄帝曾在此炼丹修仙，因此得名"黄山"。黄山以奇松、怪石、云海、温泉"四绝"闻名于世，被联合国教科文组织列入世界文化与自然双重遗产名录。</p>

      <h2>二、 奇松：生命的奇迹</h2>
      <p>黄山松是黄山的标志性景观。它们生长在悬崖峭壁之上，姿态各异，生命力顽强。最著名的有迎客松、送客松、陪客松等。迎客松伸出的枝干仿佛在热情欢迎远道而来的客人，成为黄山的象征。</p>

      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_2.png" alt="黄山奇松">
        <div class="caption">黄山奇松，扎根岩石，笑傲苍穹</div>
      </div>

      <h2>三、 怪石：大自然的雕塑</h2>
      <p>黄山怪石星罗棋布，形态万千。有的像人，有的像物，惟妙惟肖。著名的有"猴子观海"、"梦笔生花"、"仙人晒靴"等。这些怪石在不同的角度和不同的天气条件下，会呈现出不同的景象，让人叹为观止。</p>

      <h2>四、 云海：人间仙境</h2>
      <p>黄山云海是黄山最美的景观之一。当云雾弥漫山间，山峰若隐若现，仿佛置身仙境。尤其是在日出时分，金色的阳光洒在云海之上，光芒万丈，景色极为壮观。</p>

      <div class="quote-box">
        "五岳归来不看山，黄山归来不看岳。" —— 徐霞客
      </div>

      <h2>五、 温泉：天然的馈赠</h2>
      <p>黄山温泉水质清澈，温度适宜，含有多种对人体有益的矿物质。自古以来，人们就认为黄山温泉具有治病养生的功效。现在，温泉已经成为游客放松身心的好去处。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Teen2'
}
</script>

<style scoped>
.teen-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  margin: 0;
  background: #f5f0e8;
  line-height: 1.8;
}

.header {
  background: linear-gradient(135deg, #8b4513 0%, #a0522d 100%);
  color: white;
  padding: 30px 20px;
  text-align: center;
}

.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  margin: 0;
  font-size: 1.6rem;
}

h2 {
  color: #8b4513;
  border-bottom: 2px solid #cd853f;
  padding-bottom: 8px;
  margin-top: 30px;
  font-size: 1.2rem;
}

p {
  text-indent: 2em;
  margin-bottom: 20px;
  text-align: justify;
}

.img-box {
  text-align: center;
  margin: 25px 0;
}

.img-box img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.caption {
  font-size: 0.85rem;
  color: #666;
  margin-top: 10px;
}

.quote-box {
  background: #faf0e6;
  padding: 20px;
  border-left: 4px solid #8b4513;
  margin: 25px 0;
  font-style: italic;
  color: #333;
}
</style>